import {
  IconButton,
  IPanelStyles,
  Panel as OfficePanel,
  PanelType as OfficePanelType,
  Text,
} from "@fluentui/react";
import { useId } from "@fluentui/react-hooks";
import { css, ITheme, useTheme } from "cayo.ui";
import styled, { CSSProperties } from "styled-components";
import { IPanel } from "@cayo/shared/api/types/schema";
import { IClosableComponent } from "@cayo/shared/components/surfaces/Panel/types";
import logger from "@cayo/shared/libs/logger";
import { FCC } from "@cayo/shared/types/react";
import Column from "../Layout/Column";
import Row from "../Layout/Row";
import GenericScheme from "../Schemes/GenericScheme";

const Panel: FCC<IPanel & IClosableComponent & { style?: CSSProperties }> = (props) => {
  const { onClose, style, ...panelProps } = props;
  const panelId = useId("panel");
  const theme = useTheme();

  const actualType: number = OfficePanelType[props.panelType as keyof typeof OfficePanelType];
  return (
    <OfficePanel
      type={actualType}
      hasCloseButton={false}
      isOpen={true}
      styles={styles(theme, props?.style?.overflowX === "hidden")}
      isBlocking={props.isBlocking}
      onDismiss={(e) => {
        if ((e as unknown as KeyboardEvent)?.code === "Escape") {
          onClose && onClose();
        }
        logger.debug(e);
      }}
      onRenderNavigation={() => {
        return (
          <NavigationColumn>
            <StyledRow justifyContent={props.title ? "space-between" : "flex-end"} valign>
              <Text variant="xLarge" styles={{ root: { fontWeight: "bold" } }}>
                {props.title}
              </Text>
              <IconButton
                autoFocus={true}
                style={{}}
                iconProps={{ iconName: "cancel" }}
                onClick={onClose}
              />
            </StyledRow>
            {props.header && <GenericScheme {...props.header} key={panelId + "header"} />}
          </NavigationColumn>
        );
      }}
      style={style || {}}
    >
      <div className={css.pt6}>
        {panelProps.items?.length ? (
          <GenericScheme {...panelProps} key={panelId + "content"} />
        ) : (
          props.children
        )}
      </div>
    </OfficePanel>
  );
};

const styles = (theme: ITheme, hideHorizontalScroll?: boolean): Partial<IPanelStyles> => {
  return {
    content: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    commands: { background: "inherit" },
    main: {
      backgroundColor: theme.officeTheme.semanticColors.bodyStandoutBackground,
    },

    scrollableContent: [hideHorizontalScroll && { overflowX: "hidden" }],
  };
};

const StyledRow = styled(Row)`
  padding: 2px 0px 0px 0px;
`;

const NavigationColumn = styled(Column)`
  padding: 12px 10px 0px 16px;
`;

export default Panel;
